import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/video-background-removal"
    exact
    path="/consumer/features/video-background-removal"
    component={AsyncPage}
  />,
];
